import { motion } from "framer-motion";
import { MaskedLines, Eyebrow, EASE } from "./Motion";

export const PageHero = ({ eyebrow, lines, intro, testid }) => (
  <section className="relative overflow-hidden bg-[#FDFBF7] pb-14 pt-36 sm:pb-20 sm:pt-44" data-testid={testid}>
    <div aria-hidden="true" className="pointer-events-none absolute -right-32 -top-24 h-[28rem] w-[28rem] rounded-full bg-[#C86D51]/15 blur-3xl" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
        <Eyebrow>{eyebrow}</Eyebrow>
      </motion.div>
      <MaskedLines
        lines={lines}
        className="font-serif-display mt-5 text-5xl leading-[0.98] tracking-tight text-[#1E2621] sm:text-7xl lg:text-[6.5rem]"
        testid={`${testid}-title`}
      />
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.55 }}
          className="mt-8 max-w-xl text-base leading-relaxed text-[#4A554D] md:text-lg"
        >
          {intro}
        </motion.p>
      )}
    </div>
  </section>
);
